var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResourcesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "resorces-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27437",
    "data-name": "Rectangle 27437",
    width: 12,
    height: 12,
    transform: "translate(162 1537)",
    fill: "#6a6f73",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_444",
    "data-name": "Mask Group 444",
    transform: "translate(-162 -1537)",
    clipPath: "url(#resorces-icon)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_46_",
    "data-name": "svgexport-6 (46)",
    transform: "translate(162 1537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10649",
    "data-name": "Path 10649",
    d: "M.7,4.594A1.056,1.056,0,0,1,1.758,3.539H7.852A1.056,1.056,0,0,1,8.906,4.594v.352h.7V3.773a.939.939,0,0,0-.937-.937H4.453V2.367a.939.939,0,0,0-.937-.937H.937A.939.939,0,0,0,0,2.367V8.791L.7,7.665Z",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10650",
    "data-name": "Path 10650",
    d: "M7.852,4.242H1.758a.352.352,0,0,0-.352.352V6.539l.686-1.1a1.049,1.049,0,0,1,.895-.5H8.2V4.594A.352.352,0,0,0,7.852,4.242Z",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10651",
    "data-name": "Path 10651",
    d: "M9.258,10.57H.352a.352.352,0,0,1-.3-.538L2.689,5.814a.352.352,0,0,1,.3-.165H11.18a.82.82,0,0,1,.685,1.272L9.552,10.413A.352.352,0,0,1,9.258,10.57Z",
    fill: "#6a6f73"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcesIcon);
export default __webpack_public_path__ + "static/media/resources-icon.283158590e603e971ee624d8fe09daa6.svg";
export { ForwardRef as ReactComponent };